var map = {
	"./account.json": 7634,
	"./booking.json": 5350,
	"./checkinout.json": 3606,
	"./choice-settings.json": 8526,
	"./common.json": 1174,
	"./configuration.json": 9467,
	"./contact.json": 8001,
	"./department-management.json": 2987,
	"./employee.json": 443,
	"./location-list.json": 5155,
	"./location.json": 3404,
	"./management.json": 4208,
	"./menu.json": 5812,
	"./position-management.json": 3708,
	"./privacy-policy.json": 3414,
	"./schedule.json": 3262,
	"./settingMessage.json": 3792,
	"./signin.json": 7525,
	"./staff-management.json": 9873,
	"./staff-type-management.json": 2654,
	"./terms-of-service.json": 3234,
	"./timekeeping-reports.json": 743,
	"./workHours.json": 841,
	"./workinghour.json": 8080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;